module.exports = __webpack_public_path__ + "img/3.1b47ed88.png";